var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"script-question"},[_c('base-field',{class:[
            'script-question__block',
            { 'background--grey--light' : _vm.$route.meta.isAdd }
        ],attrs:{"settings":{
            label: { class: _vm.generateLabelClass, text: _vm.$t('global.question') },
            input: {
                component: 'Textarea',
                id: ("question[" + _vm.questionId + "]"),
                name: ("question[" + _vm.questionId + "]"),
                class: 'script-question__input typography--default color--default',
                disableClass: 'field__textarea--disable',
                value: _vm.values.question,
                placeholder: _vm.$t('global.writeYourQuestionHere'),
                isMissing: _vm.isMissing
            },
            alert: {
                class: 'textarea'
            },
            isEdition: _vm.isEdition,
            reset: _vm.reset,
            allowFilling: _vm.allowFilling
        }}}),_c('base-field',{attrs:{"settings":{
            label: { class: _vm.generateLabelClass, text: _vm.$t('global.questionType') },
            input: {
                component: 'InputAutocomplete',
                id: ("type[" + _vm.questionId + "]"),
                name: ("type[" + _vm.questionId + "]"),
                type: 'text',
                value: _vm.values.type.id,
                targetClass: 'field__input--default typography--default color--default',
                disableClass: 'field__textarea--disable',
                browserAutocomplete: 'off',
                dynamicData: {
                    data: _vm.inputTypes,
                    apiValue: { value: _vm.values.type.id, label: _vm.$t(("inputTypes." + (_vm.values.type.label))) }
                }
            },
            isEdition: _vm.isEdition,
            reset: _vm.reset,
            allowFilling: _vm.allowFilling
        }}}),(_vm.showAnswerOptions)?_c('possible-answers',_vm._b({},'possible-answers',{
            questions: _vm.generateQuestions,
            questionType: _vm.payload[("type[" + _vm.questionId + "]")] || _vm.questions.find( function (question) { return question.id === _vm.questionId; } ).type.id || 1,
            questionId: _vm.questionId,
            isEdition: _vm.isEdition,
            reset: _vm.reset,
            itsChainedScript: _vm.itsChainedScript,
            apiAnswers: _vm.values.nextQuestions.length ? _vm.values.nextQuestions : [],
            generateLabelClass: _vm.generateLabelClass,
            allowFilling: _vm.allowFilling
        },false)):(_vm.itsChainedScript)?_c('base-field',{attrs:{"settings":{
            label: { class: _vm.generateLabelClass, text: _vm.$t('global.nextQuestion') },
            input: {
                component: 'InputAutocomplete',
                id: ("next-question[" + _vm.questionId + "]"),
                name: ("next-question[" + _vm.questionId + "]"),
                type: 'text',
                value: _vm.values.nextQuestions.id,
                targetClass: 'field__input--default typography--default color--default',
                disableClass: 'field__textarea--disable',
                browserAutocomplete: 'off',
                placeholder: _vm.$t('global.nextQuestion'),
                dynamicData: {
                    data: _vm.generateQuestions,
                    apiValue: { value: _vm.values.nextQuestions.id, label: _vm.values.nextQuestions.label }
                }
            },
            isEdition: _vm.isEdition,
            reset: _vm.reset,
            allowFilling: _vm.allowFilling
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }